const isParseable = (string) => {
    return string && (typeof string !== 'undefined') && (string !== null)
}

export default ({ app }, inject) => {
    inject('isParseable', isParseable)
}
